import React from 'react';
import { Typewriter } from 'react-simple-typewriter';
import RJV from './RJV.png'; // ✅ Import the image like this

export default function Hero() {
  return (
    <section
      id="hero"
      data-aos="fade-up"
      className="min-h-screen flex flex-col md:flex-row justify-center items-center bg-gradient-to-b from-green-50 to-white text-center md:text-left px-4 py-12 pt-28 md:pt-12 gap-8 scroll-mt-24"
    >
      {/* Profile Image */}
      <div className="w-40 h-40 md:w-52 md:h-52 rounded-full overflow-hidden shadow-xl border-4 border-green-400">
        <img
          src={RJV} // ✅ Use the imported image variable here
          alt="Rajeevan M S"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Text Content */}
      <div>
        <h1 className="text-4xl md:text-5xl font-bold text-green-900 mb-4">
          Hi, I'm Rajeevan
        </h1>

        <h2 className="text-2xl md:text-3xl text-green-700 mb-4">
          <Typewriter
            words={['Researcher', 'Developer', 'Knowledge Curator']}
            loop={true}
            cursor
            cursorStyle="|"
            typeSpeed={70}
            deleteSpeed={50}
            delaySpeed={1500}
          />
        </h2>

        <p className="text-lg md:text-xl text-gray-700 max-w-xl mb-6">
          Passionate about creating smart information solutions that tackle real-world challenges. 
          Where data meets technology and people, I transform complexity into clarity and actionable insight.
        </p>

        {/* ⭐ Seneca Quote (Added) */}
        <blockquote
          className="text-md md:text-lg text-green-800 italic border-l-4 border-green-500 pl-4 max-w-xl"
          data-aos="fade-up"
          data-aos-delay="200"
        >
          “No one will know what you can do — not even yourself.”
          <br />
          <span className="text-green-900 font-semibold">— Seneca, <i>On Providence</i></span>
        </blockquote>
      </div>
    </section>
  );
}
